import _ from 'underscore'

export const getFieldsProperties = value => {
  return _.object([
    ['pan', value],
    ['expiryDate', value],
    ['securityCode', value]
  ])
}
